<template>
  <component
    :is="element"
    class="product-prices"
    :class="sawmill"
  >

    <span v-if="!variant" class="product-prices__fromvalue "
    :class="classVaries ? classVaries : classPrice" v-text="$string('product.prices.from')">
    </span>
    <span
      v-if="formattedCompareAtPrice && !priceFirst"
      class="product-prices__compare-at-price"
      :class="classCompareAtPrice"
    >
      <span
        v-if="currencySymbolSmall"
        class="product-prices__currency"
        v-text="currencySymbol"
      />
      <span
        class="product-prices__value"
        v-text="formattedCompareAtPrice"
      />
    </span>

    <span
      v-if="prefix"
      class="product-prices__prefix"
      :class="classPrice"
      v-text="prefix"
    />

    <span
      class="product-prices__price"
      :class="[
        classPrice,
        { 'product-prices__price--on-sale': formattedCompareAtPrice },
      ]"
    >
      <span
        v-if="currencySymbolSmall && price > 0"
        class="product-prices__currency"
        v-text="currencySymbol"
      />
      <span
        v-if="!varies"
        class="product-prices__value"
        v-text="formattedPrice"
      />

      <span
        v-else
        class="product-prices__value"
        v-text="formattedStartPrice"
      />
    </span>

    <span
      v-if="formattedCompareAtPrice && priceFirst"
      class="product-prices__compare-at-price"
      :class="classCompareAtPrice"
    >
      <span
        v-if="currencySymbolSmall"
        class="product-prices__currency"
        v-text="currencySymbol"
      />
      <span
        class="product-prices__value"
        v-text="formattedCompareAtPrice"
      />
    </span>

    <span
      v-if="available === false || checklocation() == false"
      class="product-prices__sold-out"
      :class="classPrice"
      v-text="$string('product.prices.sold_out')"
    />
  </component>
  <div v-if="affirm === true && currentCountryName === 'United States'" class="product-prices__breadpay ">
    <div  :data-price="price" :data-sku="product.sku " :id="`bread-${product.id}`" class="bread-as-low-as-container product-prices__breadpaybtn"></div>
    <div :data-price="price" :data-sku="product.sku" :id="`breadpay-${product.id}`">
     </div> 
  </div>
</template>

<script>

/**
 * Vue: Product prices (product-prices)
 * -----------------------------------------------------------------------------
 * Global product prices template.
 *
 * @param {Boolean} [available] - If the product is available.
 * @param {String} [classCompareAtPrice] - Comare at price text classes.
 * @param {String} [classPrice] - Price text classes.
 * @param {String} [classVaries] - 'From' text classes.
 * @param {Number|Boolean} compareAtPrice - Compare at price, in cents format.
 * @param {String} [element] - Custom element override.
 * @param {Boolean} [loading] - Loading state.
 * @param {Number} price - Product price, in cents format.
 * @param {Boolean} [priceFirst] - Display price before compare at price.
 * @param {Boolean} [varies] - Product variants vary in price.
 *
 */
import { formatNoDecimal } from '~/helpers/format'
export default {
  name: 'ProductPrices',

  props: {
    available: {
      type: Boolean,
      default: true,
    },
    plp: {
      type: Boolean,
      default: false,
    },
    variant :{
      type : Object,
      default: () => ({}),
    },
    classCompareAtPrice: {
      type: String,
      default: 'text-other-sale-s text-other-sale-l-desktop',
    },
    classPrice: {
      type: String,
      default: 'text-body-s-regular text-body-m-regular-desktop',
    },
    classVaries: {
      type: [Boolean, String],
      default: false,
    },
    compareAtPrice: {
      type: [Boolean, Number],
      default: false,
      required: true,
    },
    affirm: {
      type: Boolean,
      default: false,
    },
   sawmill :{
      type:String,
      default:null
    },
    element: {
      type: String,
      default: 'p',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
    startPrice: {
      type: [Boolean, Number],
      default: false,
      required: false,
    },
    price: {
      type: [Boolean, Number],
      default: 0,
      required: true,
    },
    priceFirst: {
      type: Boolean,
      default: true,
    },
    varies: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    currencySymbolSmall: {
      type: Boolean,
      default: true,
    },
    country :{
      type: String ,
      default:''
    },
    location :{
      type: String ,
      default:''
    },
    locationInventory :{
      type: [Array],
      default: () => {
        return []
      },
    }
  },

  data() {
    return {
      cnvsGlobal: true,
      currentCountryName: cnvs.store.countryName,
      productCountry : cnvs.store.country
    }
  },

  computed: {

    /**
     * Compute compare at price template.
     * @returns {String}
     */
    formattedCompareAtPrice() {
      let price = ''
      if (this.compareAtPrice && this.price < this.compareAtPrice) {
        price = this.currencySymbolSmall
          ? formatNoDecimal(this.$formatMoney(this.compareAtPrice).replace(cnvs.store.currencySymbol, ''))
          : formatNoDecimal(this.$formatMoney(this.compareAtPrice))
      }

      return price
    },

    /**
     * Compute price template.
     * @returns {String}
     */
    formattedPrice() {
      let price = ''
      if (this.price === false) {
        return this.$string('accessibility.loading')
      }

      if (this.price <= 0) {
        return this.$string('product.prices.free')
      }

      if (this.price) {
        price = this.currencySymbolSmall
          ? formatNoDecimal(this.$formatMoney(this.price).replace(cnvs.store.currencySymbol, ''))
          : formatNoDecimal(this.$formatMoney(this.price))
      }
      return price
    },

    formattedStartPrice() {
      return this.currencySymbolSmall
        ? formatNoDecimal(this.$formatMoney(this.startPrice).replace(cnvs.store.currencySymbol, ''))
        : formatNoDecimal(this.$formatMoney(this.startPrice))
    },

    currencySymbol() {
      return cnvs.store.currencySymbol
    },
  },
  mounted(){

    let breadIntervall = setInterval(function() {
      if (window.BreadPayments) {
        this.loadBreadALA();
        clearInterval(breadIntervall);
      }
    }, 100);
   this.loadall();
  },

  methods :{
    checklocation(){
      let locationArray = this.location ? this.location.split(',') : []; // Ensure it's an array
      let countryArray = this.country ? this.country.split(',') : []; 
       
              if (locationArray.includes(String(this.locationInventory)) && countryArray.includes(this.productCountry.toLowerCase())) {
                //console.log('✅ Location & country match:');
            
                  return false; // Corrected to return FALSE when inventory is unavailable
                
              }
            
        
         return true;   
    },
    loadall(){
      var merchantId = "203cbdf0-6e71-42f7-bd7d-b7142d767ba1";
        var programId = "2a1d717a-e4ea-43fc-9d2b-6844f06eda79";
        var endpoint = `https://api.platform.breadpayments.com/api/experience/servicing/as-low-as?merchantId=${merchantId}&amount=${this.price}&programId=${programId}`;
        fetch(endpoint)
          .then(response => response.json())
          .then(data => {
            const el = document.getElementById('breadpay-'+this.product.id);
            el.innerHTML = ' <div class="btn_layout"><span>AS LOW AS </span> <span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103 40" fill="%2313294B" height="30" width="50"><title>Bread</title><path d="m53.111 18.526c-2.0394 0-3.5201 0.7543-4.5258 2.0395v-1.6483h-3.604v19.556h3.604v-7.2358c1.0057 1.2852 2.4864 2.0395 4.5258 2.0395 3.7436 0 6.8169-3.2128 6.8169-7.3755s-3.0733-7.3755-6.8169-7.3755zm-0.6705 11.315c-2.207 0-3.8553-1.5924-3.8553-3.9392 0-2.3467 1.6483-3.9392 3.8553-3.9392 2.235 0 3.8836 1.5925 3.8836 3.9392 0 2.3468-1.6486 3.9392-3.8836 3.9392zm20.645-10.924v1.6483c-1.0061-1.2572-2.5144-2.0395-4.5539-2.0395-3.7155 0-6.7889 3.2128-6.7889 7.3755s3.0734 7.3755 6.7889 7.3755c2.0395 0 3.5478-0.7823 4.5539-2.0395v1.6483h3.6039v-13.969h-3.6039zm-3.8833 10.924c-2.2072 0-3.8556-1.5924-3.8556-3.9392 0-2.3467 1.6484-3.9392 3.8556-3.9392 2.235 0 3.8833 1.5925 3.8833 3.9392 0 2.3468-1.6483 3.9392-3.8833 3.9392zm19.863-10.924-3.1011 9.3869-3.6317-9.3869h-3.9395l5.7273 13.522c-0.6706 1.8719-1.6761 2.71-3.66 2.682v3.3525c3.5483 0.1956 5.9227-1.5645 7.3755-5.5875l5.085-13.969h-3.8555z"/><path d="m95.975 30.556h-2.0861v0.3273h0.8511v2.2756h0.38v-2.2756h0.855v-0.3273z"/><path d="m99.062 30.556h-0.4339l-0.9172 1.3758-0.9212-1.3758h-0.4338v2.6029h0.3844v-2.0302l0.9461 1.4129h0.0495l0.9461-1.4167v2.034h0.38v-2.6029z"/><path d="m50.423 6.5287c-1.1242 0-1.9404 0.41584-2.4949 1.1242v-3.9887h-1.9866v10.78h1.9866v-0.9086c0.5545 0.7083 1.3707 1.1242 2.4949 1.1242 2.0636 0 3.7577-1.7711 3.7577-4.0657 0-2.2947-1.6941-4.0657-3.7577-4.0657zm-0.3696 6.2372c-1.2167 0-2.1253-0.8779-2.1253-2.1715 0-1.2937 0.9086-2.1714 2.1253-2.1714 1.232 0 2.1406 0.87778 2.1406 2.1714 0 1.2936-0.9086 2.1715-2.1406 2.1715zm7.5147-4.6972v-1.3244h-1.9861v7.7002h1.9861v-3.6807c0-1.6171 1.3095-2.0791 2.3411-1.9558v-2.2177c-0.97 0-1.9405 0.43122-2.3411 1.4784zm4.8961 3.3419h5.8056c0.0461-0.2618 0.0772-0.5236 0.0772-0.8162 0-2.2639-1.6172-4.0657-3.8961-4.0657-2.4183 0-4.0661 1.7711-4.0661 4.0657 0 2.2946 1.6328 4.0657 4.22 4.0657 1.4783 0 2.6333-0.6006 3.3572-1.6479l-1.6017-0.924c-0.3388 0.4467-0.955 0.77-1.725 0.77-1.0472 0-1.8938-0.4312-2.1711-1.4476zm-0.0311-1.54c0.2311-0.98561 0.955-1.5554 2.0178-1.5554 0.8311 0 1.6628 0.44661 1.9094 1.5554h-3.9272zm13.093-3.1263v0.90861c-0.5544-0.693-1.3861-1.1242-2.5106-1.1242-2.0483 0-3.7422 1.7711-3.7422 4.0657 0 2.2946 1.6939 4.0657 3.7422 4.0657 1.1245 0 1.9562-0.4312 2.5106-1.1242v0.9086h1.9867v-7.7002h-1.9867zm-2.1406 6.0216c-1.2166 0-2.1255-0.8779-2.1255-2.1715 0-1.2937 0.9089-2.1714 2.1255-2.1714 1.2317 0 2.1406 0.87778 2.1406 2.1714 0 1.2936-0.9089 2.1715-2.1406 2.1715zm11.765-9.1016v3.9887c-0.5544-0.70839-1.3705-1.1242-2.4944-1.1242-2.0639 0-3.7578 1.7711-3.7578 4.0657 0 2.2946 1.6939 4.0657 3.7578 4.0657 1.1239 0 1.94-0.4159 2.4944-1.1242v0.9086h1.9867v-10.78h-1.9867zm-2.125 9.1016c-1.2322 0-2.1405-0.8779-2.1405-2.1715 0-1.2937 0.9083-2.1714 2.1405-2.1714 1.2167 0 2.125 0.87778 2.125 2.1714 0 1.2936-0.9083 2.1715-2.125 2.1715z"/><path d="m19.435 1.0216c-10.734 0-19.435 8.7002-19.435 19.435 0 10.734 8.7002 19.435 19.435 19.435 10.734 0 19.435-8.7003 19.435-19.435 0.0182-10.734-8.682-19.435-19.435-19.435zm3.7416 33.584-0.2542 0.1454c-1.7074 0.9263-3.8507 0.2724-4.777-1.4349l-10.571-19.635c-0.92633-1.7073-0.27244-3.8506 1.4349-4.7769l0.25428-0.14528c1.7073-0.92633 3.8506-0.29061 4.7769 1.4349l10.571 19.634c0.9081 1.7255 0.2724 3.8506-1.435 4.7769zm4.2684-5.4489-8.2098-15.239c4.2139-2.2705 9.4631-0.6903 11.734 3.5236 2.2704 4.1958 0.6902 9.4449-3.5237 11.715z"/></svg> </span> </div> <p class="btn_price">' + data.asLowAs.paymentAmountText["en-us"] + ' / MONTH <span id="financing-disclosure">*</span></p>';
          })
          .catch(error => {
            //console.log(error);
          });
  },
    getVariant(value) {
      let locations = this.location && this.location.includes(',') 
    ? this.location.split(',').map(l => l.trim()) 
    : [this.location];

      let countries = this.country && this.country.includes(',') 
        ? this.country.split(',').map(c => c.trim()) 
        : [this.country];
        
        for (let element of this.variant) {
          if (element.title === value) {
            // console.log('Checking variant:', element.id);            
              if (locations.includes(String(element.id)) && countries.includes(this.productCountry.toLowerCase())) {
                  return true; 
              }
          }
        }
        
        return false; // Return true if no false condition was met
      },
    loadBreadALA() {
   
    let breadAsLowAsContainers = document.getElementsByClassName("bread-as-low-as-container");
    let breadPlacements = []
    let setup = {integrationKey: '4ad64e7a-d472-4404-bf33-e7ff260ec543'};
    for (const container of breadAsLowAsContainers) {
        let placement = {};
        let currency = "USD";
        placement.allowCheckout = false;
        placement.domID = container.id;
        placement.order = {};
        placement.order.items = [];
  
        let price = Number(container.dataset.price);
  
        placement.order.subTotal = {value: price, currency: currency};
        placement.order.totalPrice = {value: price, currency: currency};
        placement.order.currency = currency;
        placement.order.totalShipping = {value: 0, currency: currency};
        placement.order.totalTax = {value: 0, currency: currency};
        placement.order.totalDiscounts = {value: 0, currency: currency};
        breadPlacements.push(placement);
      }
      window.BreadPayments.setup(setup);
      window.BreadPayments.on('INSTALLMENT:APPLICATION_DECISIONED', () => {});
      window.BreadPayments.on('INSTALLMENT:APPLICATION_CHECKOUT', () => {});
      window.BreadPayments.registerPlacements(breadPlacements);
      window.BreadPayments.__internal__.init();
    },
  }
}
</script>
